import React, { useState, useMemo, useEffect } from "react";

import I from "../component/Icon";

import FeesView from "../component/FeesView";

import Bdg from "../component/Badge";

import SB from "../component/SearchBox";

import apiService from "../services/apiService";

const ITEMS_PER_PAGE = 10;

const showNotification = (type, message) => {

  if (

    typeof document === "undefined" ||

    typeof window === "undefined"

  ) {

    return;

  }

  const existingNotification =

    document.getElementById(

      "fees-page-notification"

    );

  if (existingNotification) {

    existingNotification.remove();

  }

  const notification =

    document.createElement("div");

  notification.id =

    "fees-page-notification";

  notification.textContent =

    `${type === "success" ? "✓" : "✕"} ${message}`;

  Object.assign(

    notification.style,

    {

      position: "fixed",

      top: "20px",

      right: "20px",

      zIndex: "99999",

      minWidth: "280px",

      maxWidth: "420px",

      padding: "12px 16px",

      borderRadius: "8px",

      backgroundColor:

        type === "success"

          ? "#d1e7dd"

          : "#f8d7da",

      color:

        type === "success"

          ? "#0f5132"

          : "#842029",

      border:

        type === "success"

          ? "1px solid #badbcc"

          : "1px solid #f5c2c7",

      fontSize: "14px",

      fontWeight: "600",

      boxShadow:

        "0 4px 12px rgba(0,0,0,0.15)",

    }

  );

  document.body.appendChild(

    notification

  );

  window.setTimeout(() => {

    if (notification.parentNode) {

      notification.remove();

    }

  }, 3000);

};

const getApiErrorMessage = (

  error,

  fallback

) => {

  const data =

    error?.response?.data;

  if (

    typeof data === "string" &&

    data.trim()

  ) {

    return data;

  }

  if (

    data &&

    typeof data === "object"

  ) {

    if (

      data?.errors &&

      typeof data.errors === "object"

    ) {

      const validationErrors =

        Object.entries(data.errors)

          .flatMap(

            ([key, value]) => {

              const messages =

                Array.isArray(value)

                  ? value

                  : [value];

              return messages.map(

                (message) =>

                  `${key}: ${message}`

              );

            }

          )

          .filter(Boolean)

          .join(" ");

      if (validationErrors) {

        return validationErrors;

      }

    }

    return (

      data?.failureReason ||

      data?.FailureReason ||

      data?.message ||

      data?.Message ||

      data?.title ||

      data?.error ||

      error?.message ||

      fallback

    );

  }

  return (

    error?.message ||

    fallback

  );

};

export default function FeesPage({

  schools = [],

}) {

  const [sub, setSub] =

    useState("list");

  const [view, setView] =

    useState(null);

  const [q, setQ] =

    useState("");

  const [scf, setScf] =

    useState("All Schools");

  const [fees, setFees] =

    useState([]);

  const [loading, setLoading] =

    useState(true);

  const [error, setError] =

    useState("");

  const [

    currentPage,

    setCurrentPage,

  ] = useState(1);

  const fetchPayments = async () => {

    try {

      setLoading(true);

      setError("");

      const response =

        await apiService.get(

          "Payment/getAllPayment?includeInActive=false"

        );

      const data =

        response?.data;

      if (

        data?.isSuccess === false ||

        data?.IsSuccess === false

      ) {

        throw new Error(

          data?.failureReason ||

          data?.FailureReason ||

          data?.message ||

          data?.Message ||

          "Failed to fetch payments"

        );

      }

      const output =

        data?.output ??

        data?.Output ??

        data?.data ??

        data?.Data ??

        [];

      setFees(

        Array.isArray(output)

          ? output

          : []

      );

    } catch (err) {

      console.error(

        "Error fetching payments:",

        err

      );

      const message =

        getApiErrorMessage(

          err,

          "Failed to load payments"

        );

      setError(message);

      showNotification(

        "error",

        message

      );

    } finally {

      setLoading(false);

    }

  };

  useEffect(() => {

    fetchPayments();

  }, []);

  const filtered = useMemo(() => {

    return fees.filter((f) => {

      const searchText = [

        f.studentName,

        f.schoolName,

      ]

        .join(" ")

        .toLowerCase();

      const matchesSearch =

        searchText.includes(

          q.toLowerCase()

        );

      const matchesSchool =

        scf === "All Schools" ||

        f.schoolName === scf;

      return (

        matchesSearch &&

        matchesSchool

      );

    });

  }, [fees, q, scf]);

  const totalAmount =

    fees.reduce(

      (a, f) =>

        a +

        Number(

          f.total || 0

        ),

      0

    );

  const totalPaid =

    fees.reduce(

      (a, f) =>

        a +

        Number(

          f.paid || 0

        ),

      0

    );

  const totalPages =

    Math.max(

      1,

      Math.ceil(

        filtered.length /

          ITEMS_PER_PAGE

      )

    );

  useEffect(() => {

    if (

      currentPage >

      totalPages

    ) {

      setCurrentPage(

        totalPages

      );

    }

  }, [

    currentPage,

    totalPages,

  ]);

  useEffect(() => {

    setCurrentPage(1);

  }, [q, scf]);

  const pageNumbers =

    Array.from(

      {

        length:

          totalPages,

      },

      (_, index) =>

        index + 1

    );

  const paginatedFees =

    filtered.slice(

      (

        currentPage - 1

      ) * ITEMS_PER_PAGE,

      currentPage *

        ITEMS_PER_PAGE

    );

  const showingFrom =

    filtered.length === 0

      ? 0

      : (

          currentPage - 1

        ) *

          ITEMS_PER_PAGE +

        1;

  const showingTo =

    filtered.length === 0

      ? 0

      : Math.min(

          currentPage *

            ITEMS_PER_PAGE,

          filtered.length

        );

  if (

    sub === "view" &&

    view

  ) {

    return (

      <FeesView

        fee={view}

        onBack={() => {

          setSub("list");

          setView(null);

        }}

      />

    );

  }

  return (

    <>

      
      <style>{`
        .fees-pagination-footer {box-sizing:border-box; display:flex !important; flex-direction:row !important; flex-wrap:nowrap !important; align-items:center; justify-content:space-between; gap:8px !important; min-width:0; max-width:100%; overflow:hidden;}
        .fees-pagination-count {flex:0 0 auto; white-space:nowrap; min-width:0;}
        .fees-pagination-controls {display:flex !important; flex:1 1 0; min-width:0; width:auto; max-width:100%; flex-wrap:nowrap !important; gap:5px; align-items:center; justify-content:flex-end; overflow:hidden;}
        .fees-pagination-nav {flex:0 0 auto; white-space:nowrap;}
        .fees-pagination-numbers {flex:0 1 auto; min-width:0; max-width:100%; display:flex !important; flex-wrap:nowrap !important; overflow-x:auto; overflow-y:hidden; gap:4px; scrollbar-width:thin; -webkit-overflow-scrolling:touch; overscroll-behavior-x:contain;}
        .fees-pagination-number {flex:0 0 auto;}
        @media(max-width:600px) {
          .fees-pagination-footer {gap:5px !important; padding-left:0 !important; padding-right:0 !important;}
          .fees-pagination-count {font-size:9px !important;}
          .fees-pagination-controls {gap:3px !important;}
          .fees-pagination-nav {min-width:43px !important; padding:0 4px !important; font-size:10px !important;}
          .fees-pagination-number {min-width:28px !important; padding:0 5px !important;}
        }
      `}</style>
<div className="ph">

        <div className="ph-t">

          Fees Management

        </div>

      </div>

      <div className="mr">

        {/* Total */}

        <div

          className="mc"

          style={{

            background:

              "#EFF6FF",

          }}

        >

          <div

            className="mv"

            style={{

              color:

                "#2563EB",

            }}

          >

            ₹

            {totalAmount.toLocaleString()}

          </div>

          <div className="ml">

            Total

          </div>

        </div>

        {/* Collected */}

        <div

          className="mc"

          style={{

            background:

              "#ECFDF5",

          }}

        >

          <div

            className="mv"

            style={{

              color:

                "#10B981",

            }}

          >

            ₹

            {totalPaid.toLocaleString()}

          </div>

          <div className="ml">

            Collected

          </div>

        </div>

        <div

          style={{

            marginLeft:

              "auto",

            display: "flex",

            gap: 8,

            alignItems:

              "center",

          }}

        >

        </div>

      </div>

      <div className="toolbar">

        <SB

          value={q}

          onChange={setQ}

          placeholder="Search student, school…"

        />

        {/* <select

          value={scf}

          onChange={(e) => setScf(e.target.value)}

        >

          <option value="All Schools">

            All Schools

          </option>

          {schools?.map((school) => (

            <option

              key={school.id}

              value={school.schoolName}

            >

              {school.schoolName}

            </option>

          ))}

        </select> */}

      </div>

      <div className="card">

        <div className="tw">

          {loading ? (

            <div

              style={{

                padding: 20,

              }}

            >

              Loading payments...

            </div>

          ) : error ? (

            <div

              style={{

                padding: 20,

                textAlign:

                  "center",

              }}

            >

              <div

                style={{

                  color:

                    "#dc2626",

                  marginBottom:

                    "12px",

                }}

              >

                {error}

              </div>

              <button

                type="button"

                className="btn btn-g btn-sm"

                onClick={

                  fetchPayments

                }

              >

                Retry

              </button>

            </div>

          ) : (

            <table>

              <thead>

                <tr>

                  <th>

                    Student

                  </th>

                  <th>

                    School

                  </th>

                  <th>

                    Total

                  </th>

                  <th>

                    Paid

                  </th>

                  <th>

                    Status

                  </th>

                  <th>

                    Actions

                  </th>

                </tr>

              </thead>

              <tbody>

                {filtered.length ===

                0 ? (

                  <tr>

                    <td

                      colSpan="6"

                      style={{

                        textAlign:

                          "center",

                        padding: 30,

                      }}

                    >

                      No payments found

                    </td>

                  </tr>

                ) : (

                  paginatedFees.map(

                    (f) => (

                      <tr

                        key={

                          f.paymentId

                        }

                      >

                        <td className="tdb">

                          {

                            f.studentName

                          }

                        </td>

                        <td className="td2">

                          {

                            f.schoolName

                          }

                        </td>

                        <td

                          style={{

                            fontWeight:

                              600,

                          }}

                        >

                          ₹

                          {Number(

                            f.total ||

                              0

                          ).toLocaleString()}

                        </td>

                        <td

                          style={{

                            color:

                              "var(--gd)",

                            fontWeight:

                              600,

                          }}

                        >

                          ₹

                          {Number(

                            f.paid ||

                              0

                          ).toLocaleString()}

                        </td>

                        <td>

                          <Bdg

                            type="green"

                            label="Paid"

                          />

                        </td>

                        <td>

                          <div className="ra">

                            <button

                              className="btn btn-p btn-sm"

                              onClick={() => {

                                setView(

                                  f

                                );

                                setSub(

                                  "view"

                                );

                              }}

                            >

                              <I

                                n="eye"

                                s={11}

                                c="#fff"

                              />

                              View

                            </button>

                          </div>

                        </td>

                      </tr>

                    )

                  )

                )}

              </tbody>

            </table>

          )}

        </div>

        {!loading &&

          !error &&

          filtered.length >

            0 && (

            <div className="fees-pagination-footer"

              style={{

                width: "100%",

                display: "flex",

                alignItems:

                  "center",

                justifyContent:

                  "space-between",

                gap: "16px",

                marginTop:

                  "16px",

                padding:

                  "12px 4px 4px",

                borderTop:

                  "1px solid #eef2f7",

                flexWrap:

                  "wrap",

              }}

            >

              <div className="fees-pagination-count"

                style={{

                  display:

                    "flex",

                  alignItems:

                    "center",

                  whiteSpace:

                    "nowrap",

                  fontSize:

                    "11px",

                  lineHeight:

                    "16px",

                  color:

                    "var(--t3)",

                }}

              >

                Showing{" "}

                <span

                  style={{

                    margin:

                      "0 4px",

                    fontWeight:

                      600,

                    color:

                      "var(--t2)",

                  }}

                >

                  {showingFrom}

                </span>

                –

                <span

                  style={{

                    margin:

                      "0 4px",

                    fontWeight:

                      600,

                    color:

                      "var(--t2)",

                  }}

                >

                  {showingTo}

                </span>

                {" "}of{" "}

                <span

                  style={{

                    marginLeft:

                      "4px",

                    fontWeight:

                      600,

                    color:

                      "var(--t2)",

                  }}

                >

                  {

                    filtered.length

                  }

                </span>

              </div>

              <div className="fees-pagination-controls"

                style={{

                  display:

                    "flex",

                  alignItems:

                    "center",

                  gap: "5px",

                  flexWrap:

                    "wrap",

                }}

              >

                <button className="fees-pagination-nav"

                  type="button"

                  disabled={

                    currentPage ===

                    1

                  }

                  onClick={() =>

                    setCurrentPage(

                      (page) =>

                        Math.max(

                          1,

                          page - 1

                        )

                    )

                  }

                  style={{

                    height:

                      "32px",

                    minWidth:

                      "66px",

                    padding:

                      "0 10px",

                    display:

                      "inline-flex",

                    alignItems:

                      "center",

                    justifyContent:

                      "center",

                    gap: "3px",

                    border:

                      "1px solid #e2e8f0",

                    borderRadius:

                      "6px",

                    background:

                      currentPage ===

                      1

                        ? "#f8fafc"

                        : "#fff",

                    color:

                      currentPage ===

                      1

                        ? "#cbd5e1"

                        : "#475569",

                    fontSize:

                      "11px",

                    fontWeight:

                      500,

                    cursor:

                      currentPage ===

                      1

                        ? "not-allowed"

                        : "pointer",

                    transition:

                      "all 0.15s ease",

                  }}

                >

                  <span

                    style={{

                      fontSize:

                        "16px",

                      lineHeight:

                        1,

                    }}

                  >

                    ‹

                  </span>

                  Back

                </button>

                <div className="fees-pagination-numbers"

                  style={{

                    display:

                      "flex",

                    alignItems:

                      "center",

                    gap: "4px",

                    flexWrap:

                      "wrap",

                  }}

                >

                  {pageNumbers.map(

                    (page) => (

                      <button className="fees-pagination-number"

                        key={page}

                        type="button"

                        onClick={() =>

                          setCurrentPage(

                            page

                          )

                        }

                        style={{

                          height:

                            "32px",

                          minWidth:

                            "32px",

                          padding:

                            "0 9px",

                          display:

                            "inline-flex",

                          alignItems:

                            "center",

                          justifyContent:

                            "center",

                          border:

                            currentPage ===

                            page

                              ? "1px solid #2563eb"

                              : "1px solid #e2e8f0",

                          borderRadius:

                            "6px",

                          background:

                            currentPage ===

                            page

                              ? "#2563eb"

                              : "#fff",

                          color:

                            currentPage ===

                            page

                              ? "#fff"

                              : "#475569",

                          fontSize:

                            "11px",

                          fontWeight:

                            600,

                          cursor:

                            "pointer",

                          transition:

                            "all 0.15s ease",

                        }}

                      >

                        {page}

                      </button>

                    )

                  )}

                </div>

                <button className="fees-pagination-nav"

                  type="button"

                  disabled={

                    currentPage >=

                    totalPages

                  }

                  onClick={() =>

                    setCurrentPage(

                      (page) =>

                        Math.min(

                          totalPages,

                          page + 1

                        )

                    )

                  }

                  style={{

                    height:

                      "32px",

                    minWidth:

                      "66px",

                    padding:

                      "0 10px",

                    display:

                      "inline-flex",

                    alignItems:

                      "center",

                    justifyContent:

                      "center",

                    gap: "3px",

                    border:

                      "1px solid #e2e8f0",

                    borderRadius:

                      "6px",

                    background:

                      currentPage >=

                      totalPages

                        ? "#f8fafc"

                        : "#fff",

                    color:

                      currentPage >=

                      totalPages

                        ? "#cbd5e1"

                        : "#475569",

                    fontSize:

                      "11px",

                    fontWeight:

                      500,

                    cursor:

                      currentPage >=

                      totalPages

                        ? "not-allowed"

                        : "pointer",

                    transition:

                      "all 0.15s ease",

                  }}

                >

                  Next

                  <span

                    style={{

                      fontSize:

                        "16px",

                      lineHeight:

                        1,

                    }}

                  >

                    ›

                  </span>

                </button>

              </div>

            </div>

          )}

      </div>

    </>

  );

}